module.exports = __webpack_public_path__ + "static/media/default-training_l2desktop.75a17ce1.jpg";